(function(){
  var fill = document.getElementById('readProgressFill');
  var article = document.querySelector('article');
  if(!fill || !article) return;
  function update(){
    var docHeight = article.offsetHeight - window.innerHeight;
    var pct = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
    pct = Math.min(100, Math.max(0, pct));
    fill.style.width = pct + '%';
  }
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update);
  update();
})();

(function(){
  if(!('IntersectionObserver' in window)){
    document.querySelectorAll('.draw,.fade-in').forEach(function(el){ el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.querySelectorAll('.draw,.fade-in').forEach(function(el){ el.classList.add('in'); });
        io.unobserve(entry.target);
      }
    });
  }, {threshold:.35});
  document.querySelectorAll('.chart-card').forEach(function(c){ io.observe(c); });
})();

(function(){
  var bar = document.getElementById('stickyCta');
  var sentinel = document.getElementById('revivalSentinel');
  if(!bar || !sentinel) return;
  function update(){
    var rect = sentinel.getBoundingClientRect();
    if(rect.top <= 0){ bar.classList.add('show'); }
    else { bar.classList.remove('show'); }
  }
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update);
  update();
})();
